import '@nettbureau/theme';
import 'radash';
import { parseShadow } from '../parsers/shadow.js';
import 'polished';

/**
 * Generates CSS for applying shadow to an element.
 *
 * @param shadow - The level of shadow to apply.
 */ function shadow(shadow1 = 'none') {
    return (theme)=>({
            boxShadow: parseShadow(theme, shadow1)
        });
}

export { shadow };
//# sourceMappingURL=shadow.js.map
